<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
     
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateRangeText"
        :label="label"
        append-icon="mdi-timetable"
        solo
        hide-details
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title scrollable
      range
      locale="zh-cn"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="cancel">{{$vuetify.lang.t('$vuetify.custom.cancelBtn')}}
      </v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(date)">
        {{$vuetify.lang.t('$vuetify.custom.okBtn')}}
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>
<style></style>
<script>
  export default {
    model: {
      prop: 'value',
      event: 'parent-event'
    },
    props:{
      value:Array,
      label:String
    },
    data:()=>({
      menu:false,
      date:[]
    }),
    computed: {
      dateRangeText() {
        this.date.sort((a,b)=>{
          return Date.parse(a) - Date.parse(b)
        })
        this.$emit('parent-event',this.date)
        return this.date.join(' ~ ')
      },
    },
    methods:{
      cancel(){
        this.menu = false
        this.date=[]
        this.$emit('parent-event',this.date)
      }
    }
  }
</script>
